__turbopack_context__.v({
  "container": "ImagePlacement-module-scss-module__3KLv0G__container",
  "containerAmp": "ImagePlacement-module-scss-module__3KLv0G__containerAmp",
});
